import { render, staticRenderFns } from "./puInstrumentOrderAction.vue?vue&type=template&id=2ebd1faa&scoped=true"
import script from "./puInstrumentOrderAction.vue?vue&type=script&lang=js"
export * from "./puInstrumentOrderAction.vue?vue&type=script&lang=js"
import style0 from "./puInstrumentOrderAction.vue?vue&type=style&index=0&id=2ebd1faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd1faa",
  null
  
)

export default component.exports